import {Component, Input, OnInit} from '@angular/core';
import {StylingCheckService} from 'src/app/services/styling-check/styling-check.service';
import {environment} from 'src/environments/environment';
import {IdService} from "../../../../services/id/id.service";

@Component({
    selector: 'xlog-login-apps',
    templateUrl: './login-apps.component.pug',
    styleUrls: ['./login-apps.component.scss'],
    standalone: false
})
export class LoginAppsComponent implements OnInit {
    @Input() appAccess: boolean;
    @Input() userName: string;

    appUrl = environment.APP_URL;
    adminUrl = environment.ADMIN_URL;

    constructor(
        private id: IdService,
        private stylingCheck: StylingCheckService
    ) {}

    ngOnInit() {
        this.stylingCheck.setClassic(true);
    }

    logout() {
        this.id.logout();
    }
}
